import { Placeholder, Skeleton, Stack } from '@sixui/ui';

import type { ITableRowProps } from '~/components/molecules/Table/TableRow';
import { Table } from '~/components/molecules/Table';

export type IArticleListItemSkeletonProps = ITableRowProps;

export const ArticleListItemSkeleton: React.FC<
  IArticleListItemSkeletonProps
> = (props) => {
  const { ...other } = props;

  return (
    <Table.Row {...other}>
      <Stack as={Table.Body} horizontal gap={3}>
        <Placeholder width={64} height={64}>
          <Skeleton variant="overlay" />
        </Placeholder>
        <Stack gap={1}>
          <Skeleton length={{ min: 8, max: 56 }} />
          <Skeleton length={32} />
        </Stack>
      </Stack>
      <Table.Body />
      <Table.Body />
      <Table.Body />
    </Table.Row>
  );
};
